function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.85 4.85c-3.1 0-5.6 2.5-5.6 5.55s2.5 5.55 5.6 5.55c3.1 0 5.6-2.5 5.6-5.55-.05-3.05-2.55-5.55-5.6-5.55zm2.5 5.35L8.2 12.25v-4.1z",
  fill: "none",
  strokeWidth: ".5",
  stroke: "currentColor"
}));